import Styled from "styled-components";

export const TitleProduct = Styled.p`
`;

export const Box = Styled.div`
`;

export const SellerName = Styled.h2`
 font-weight: 500;
 style: medium;
 font-size: 16px;
 line-height: 150%;
 letter-spacing: 0%;
 color: ${props => props.theme.whitelabel?.text_primary_color};
`;

export const LabelName = Styled.p`
 font-weight: 500;
 style: medium;
 font-size: 14px;
 line-height: 150%;
 letter-spacing: 0%;
 color: ${props => props.theme.whitelabel?.text_primary_color};
`;

export const Line = Styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
  border: solid 1px #F0F0F0;
`;

